<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <TagIcon />
      <h2 class="text-lg font-medium mr-auto">{{ $t('branchPlace.list') }}</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <router-link
          :to="{
            name: 'side-menu-branch-places-add',
            params: { branchUUID: this.$route.params.branchUUID }
          }"
        >
          <button class="btn btn-primary shadow-md mr-2">
            {{ $t('branchPlace.add') }}
          </button>
        </router-link>
        <router-link
          :to="{ name: 'side-menu-branches' }"
          tag="a"
          class="btn shadow-md flex items-center"
        >
          <ArrowLeftCircleIcon class="w-4 h-4 mr-2" /> {{ $t('common.back') }}
        </router-link>
      </div>
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <ListTable
        :branchUUID="this.$route.params.branchUUID"
      />
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ListTable from '@/components/branch-places/ListTable'

export default defineComponent({
  components: {
    ListTable
  },
  setup() {
    return {}
  }
})
</script>
